import React from "react";
import { Route, Switch } from "react-router-dom";

import { providerRoute } from "@/config/roles";
import WorkingHours from "@/portals/(shared)/components/WorkingHours";

import { ProviderProfile } from "./ProviderProfile";

const BASE_ROUTE = providerRoute + "/profile";
const hours = BASE_ROUTE + "/hours";

export function ProviderProfileRouter() {
  return (
    <Switch>
      <Route path={hours} render={(props) => <WorkingHours {...props} />} />
      <Route component={ProviderProfile} path={BASE_ROUTE} />
    </Switch>
  );
}
